import { ApiCall } from '../helpers/ApiCall';
import Events from '../helpers/Events';
import { FlowMoments, FlowSteps } from '../models/FlowSteps';

export class BaseComponent {
  public static async logStep(step: FlowSteps, moment: FlowMoments) {
    Events.flowEvent(step, moment);
    try {
      await ApiCall.instance.AddStep(step, moment);
    } catch (e) {}
  }

  public static async initialize(flowStep: FlowSteps) {
    Events.flowEvent(flowStep, FlowMoments.Initialized);
    try {
      await ApiCall.instance.AddStep(flowStep, FlowMoments.Initialized);
    } catch (e) {}
  }

  public static async finalize(flowStep: FlowSteps) {
    Events.flowEvent(flowStep, FlowMoments.Finalized);
    try {
      await ApiCall.instance.AddStep(flowStep, FlowMoments.Finalized);
    } catch (e) {}
  }
}
